import React from "react";
// import { useTranslationContext } from "@providers/TranslationProvider";
import Header from "@components/Header";
import Footer from "@components/Footer";

import Banner from "@components/Banner";
import SectionPost from "@components/Story/SectionPost";
import TabCategory from "@components/Story/TabCategory";
import Interested from "@components/Story/Interested";
import { useTranslationContext } from "@providers/TranslationProvider";
// import { usePageContext } from "@providers/PageProvider";
import styles from "./Story.module.scss";
import _ from "lodash";

const View = () => {
  const { i18n } = useTranslationContext();
  return (
    <div className="storyPage" data-scroll-container>
      <Header />
      <Banner
        image={{
          src: "/story/banner.jpg",
          alt: i18n.t("Stories.title"),
        }}
        title={i18n.t("Stories.title")}
        label={<TabCategory />}
        contentProps={{ className: styles.banner }}
        labelProps={{ className: styles.label }}
      />
      <SectionPost />
      <Interested />
      {/* <About />
      <OurJourney />
      <OurHotel />
      <OurStory />
      <StayInpired /> */}
      <Footer hideSocialIcons />
    </div>
  );
};

export default View;
